import React from 'react';
import PropTypes from 'prop-types';
import StyledCard, { NoteTitle } from './styled';
import Note from './components/Note';

const getDriverNote = ({ collectionNote }) => collectionNote;
const getMechanicNote = ({ notes }) => {
  const mechanicNote = notes.filter(
    ({ noteType, status }) => noteType === 'customer-to-mechanic' && status === 'ACTIVE'
  );
  if (mechanicNote.length === 0) return undefined;
  return mechanicNote[0].content;
};

const CustomerNotes = ({ booking }) => {
  const driverNote = getDriverNote(booking);
  const mechanicNote = getMechanicNote(booking);
  if (!driverNote && !mechanicNote) return <></>;
  return (
    <StyledCard>
      <NoteTitle>Customer&apos;s notes</NoteTitle>
      {mechanicNote && <Note title="For the mechanic:" note={mechanicNote} />}
      {driverNote && <Note title="For the driver:" note={driverNote} />}
    </StyledCard>
  );
};

CustomerNotes.propTypes = {
  booking: PropTypes.object,
};

CustomerNotes.defaultProps = {
  booking: {},
};

export default CustomerNotes;
